import { defaultHttpClient } from '../../httpClient';
import type { MarketLiveCampaignResponse } from './types';

export const getRelatedLiveCampaign = (goodsSno: number) => {
  return defaultHttpClient
    .request<MarketLiveCampaignResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/related-live-campaign/`,
    })
    .then(result => result.data)
    .then(result => result.campaign);
};
